var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOccupancyStanding = function SvgOccupancyStanding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 17-.334-6.005a3.171 3.171 0 0 0-6.332 0L1.5 17zM15.5 17l-.334-6.005a3.171 3.171 0 0 0-6.332 0L8.5 17z"
  }))));
};
export default SvgOccupancyStanding;